
import React from 'react';
import Logo from './Logo';

const HeroSection: React.FC = () => {
    const scrollToPrograms = () => {
        const section = document.getElementById('programs');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleGetInvolvedClick = () => {
      const event = new CustomEvent('setActiveJoinUsTab', { detail: 'volunteer' });
      window.dispatchEvent(event);
      document.getElementById('joinus')?.scrollIntoView({ behavior: 'smooth' });
    };
    
  return (
    <section id="home" className="py-20 md:py-32 bg-jskool-cream">
      <div className="container mx-auto px-6 text-center flex flex-col items-center">
        <div className="flex flex-col items-center mb-6">
          <Logo className="h-24 md:h-32" />
          <div className="bg-jskool-gold text-jskool-dark font-semibold px-6 py-2 rounded-lg mt-4 shadow-md text-center">
              <p className="font-body text-xl italic">Learning Jainism is Kool!</p>
          </div>
        </div>
        <h1 className="text-4xl md:text-5xl font-heading font-black mt-6 text-jskool-dark">Jain Pathshala, <span className="text-jskool-blue">Reimagined!</span></h1>
        <p className="max-w-3xl mx-auto mt-4 text-lg md:text-xl text-jskool-dark/80 font-medium">
          Empowering Pathshala teachers with effective, scalable tools and helping parents teach Jain values with minimal effort through engaging comics, animations, and gamified content. Our platform is open to anyone, from any background, eager to explore the timeless teachings of Jainism. We embrace all Jain traditions, uniting our diverse family under one modern learning platform.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
          <button onClick={scrollToPrograms} className="bg-jskool-blue hover:bg-blue-700 text-white font-bold font-heading py-3 px-8 rounded-full text-lg shadow-lg transform hover:scale-105 transition-all duration-300">
            Explore Courses
          </button>
          <button onClick={handleGetInvolvedClick} className="bg-jskool-gold hover:bg-yellow-500 text-jskool-dark font-bold font-heading py-3 px-8 rounded-full text-lg shadow-lg transform hover:scale-105 transition-all duration-300">
            Get Involved
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;